import { SubscriptionTypeFlags } from '../../../../../shared/constants/user-info/subscription';
import { CustomerSubscription } from '../../../../interfaces/customerSubscription';

export const getPriceForSubscription = (
  subscription: CustomerSubscription,
  subscriptionTypeFlags: SubscriptionTypeFlags,
) => {
  let price;

  if (subscriptionTypeFlags.REGULAR) {
    price = subscription.initialPlanPrice;
  } else if (subscriptionTypeFlags.REACTIVATION || subscriptionTypeFlags.SCAN_IQ) {
    price = subscription.monthlyRenewalPrice;
  }

  return price || 0;
};
